import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const InlandFloodEULegend = ({ periodOfTime, copyright, country }) => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{`${t("riskAssessment.inlandFlood")} (${country}) - ${periodOfTime} yr`}</b>
      </div>
      <div>
        <span style={legendItemStyle("#2b83ba")}></span>
        {t("levels.low")}: 0 &lt; fd (m) &lt; 0.5
      </div>
      <div>
        <span style={legendItemStyle("#91cba8")}></span>
        {t("levels.moderate")}: 0.5 &le; fd (m) &lt; 1
      </div>
      <div>
        <span style={legendItemStyle("#f4fabb")}></span>
        {t("levels.significant")}: 1 &le; fd (m) &lt; 2
      </div>
      <div>
        <span style={legendItemStyle("#fdb367")}></span>
        {t("levels.high")}: 2 &le; fd (m) &lt; 3
      </div>
      <div>
        <span style={legendItemStyle("#d7191c")}></span>
        {t("levels.veryHigh")}: fd (m) &ge; 3
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          fd = {t("legend.costalFD")}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromJRC")}, {copyright}
        </span>
      </div>
    </div>
  );
};

export default InlandFloodEULegend;
